export class TileObject{
    isOccupied = false;
    x = 0;
    y = 0;
    debugGraphic = null;
}